'use client'
import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { useState, useCallback } from 'react';
import { DynamicError } from '@dynamic-labs/utils';
import { getDynamicClient } from '../../../../client/client.js';
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import { useViewContext } from '../../../ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import { isSSR } from '../../../../shared/utils/functions/isSSR/isSSR.js';
import '../../../../utils/constants/colors.js';
import '../../../../utils/constants/values.js';
import { useEffectOnceCondition } from '../../../../shared/utils/hooks/useEffectOnceCondition/useEffectOnceCondition.js';
import '../../../../shared/consts/index.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import { searchSocialStorageByState, deleteSocialStorage } from '../../../../utils/functions/socialStorage/socialStorage.js';
import { getSocialSignInProviderForProviderEnum } from '../../../../utils/functions/getSocialSignInProviderForProviderEnum/getSocialSignInProviderForProviderEnum.js';
import '../../../../store/state/nonce/nonce.js';
import '@dynamic-labs-sdk/client/core';
import '@dynamic-labs-sdk/client';
import '../../../../events/dynamicEvents.js';
import '../../../../store/state/projectSettings/projectSettings.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../locale/locale.js';
import '../../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../../store/state/primaryWalletId/primaryWalletId.js';
import '../../../../store/state/connectedWalletsInfo/connectedWalletsInfo.js';
import '../../../DynamicContext/DynamicContext.js';
import '../../../../store/state/loadingAndLifecycle/loadingAndLifecycle.js';
import '../../../../store/state/authMode/authMode.js';
import { useInternalDynamicContext } from '../../../DynamicContext/useDynamicContext/useInternalDynamicContext/useInternalDynamicContext.js';
import '../../../CaptchaContext/CaptchaContext.js';
import '../../../ErrorContext/ErrorContext.js';
import '../../../AccessDeniedContext/AccessDeniedContext.js';
import '../../../AccountExistsContext/AccountExistsContext.js';
import '../../../UserWalletsContext/UserWalletsContext.js';
import '../../../VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../../../utils/functions/compareChains/compareChains.js';
import '../../../../views/Passkey/utils/findPrimaryEmbeddedChain/findPrimaryEmbeddedChain.js';
import '../../../ThemeContext/ThemeContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import 'bs58';
import '@dynamic-labs/types';
import '../../SocialRedirectContext.js';
import { useSocialAuth } from '../../../../utils/hooks/useSocialAuth/useSocialAuth.js';
import 'yup';
import '../../../MockContext/MockContext.js';
import '../../../../views/CollectUserDataView/useFields.js';
import '../../../FieldsStateContext/FieldsStateContext.js';
import '../../../UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../../../store/state/walletOptions/walletOptions.js';
import 'react-i18next';
import '../../../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../../../components/Alert/Alert.js';
import '../../../WalletContext/WalletContext.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../components/IconButton/IconButton.js';
import '../../../../components/InlineWidget/InlineWidget.js';
import '../../../../components/Input/Input.js';
import '../../../../components/IsBrowser/IsBrowser.js';
import '../../../../components/MenuList/Dropdown/Dropdown.js';
import '../../../../components/OverlayCard/OverlayCard.js';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../../../components/Popper/Popper/Popper.js';
import '../../../../components/Popper/PopperContext/PopperContext.js';
import 'react-focus-lock';
import 'qrcode';
import 'formik';
import '../../../../utils/hooks/useSubdomainCheck/useSubdomainCheck.js';
import { useEffectOnce } from '../../../../utils/hooks/useEffectOnce/useEffectOnce.js';
import '../../../WalletGroupContext/WalletGroupContext.js';
import '../../../IpConfigurationContext/IpConfigurationContext.js';
import '../../../ConnectWithOtpContext/ConnectWithOtpContext.js';
import '../../../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../../LoadingContext/LoadingContext.js';
import { useWidgetContext } from '../../../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../../FooterAnimationContext/index.js';
import '../../../ErrorContext/hooks/useErrorText/useErrorText.js';
import '../../../../utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import '../../../PasskeyContext/PasskeyContext.js';
import '../../../../widgets/DynamicWidget/helpers/convertExchangeKeyAndProviderEnum.js';
import '../../../../store/state/sendBalances.js';
import '../../../../store/state/connectorsInitializing/connectorsInitializing.js';
import '../../../../components/OverlayCardBase/OverlayCardTarget/OverlayCardTarget.js';
import '../../../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import '../../../../views/TransactionConfirmationView/TransactionConfirmationView.js';
import '../../../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../../OnrampContext/OnrampContext.js';
import '../../../../widgets/DynamicWidget/views/ReceiveWalletFunds/ReceiveWalletFunds.js';
import '../../../../../index.js';
import '../../../../store/state/tokenBalances.js';
import '../../../../shared/utils/functions/getInitialUrl/getInitialUrl.js';
import { usePromptAmountAndFundWithExchange } from '../../../../utils/hooks/usePromptAndFundWithExchange/usePromptAndFundWithExchange.js';

const useRedirectSocialHandler = ({ setSocialProvider, }) => {
    const { clearStackAndPush } = useViewContext();
    const { setDynamicWidgetView } = useWidgetContext();
    const promptAmountAndFundWithExchange = usePromptAmountAndFundWithExchange();
    const [socialStorageItem, setSocialStorageItem] = useState(null);
    const { sdkHasLoaded, setShowAuthFlow, isRenderingEmbeddedAuthFlow, setShowDynamicUserProfile, redirectUrl, } = useInternalDynamicContext();
    const { completeConnection } = useSocialAuth({});
    const updateInterfaceStateForSignIn = useCallback((socialStorageItem) => {
        const socialSignInProvider = getSocialSignInProviderForProviderEnum(socialStorageItem.provider);
        setSocialProvider(socialSignInProvider);
        clearStackAndPush('social-redirect-view');
        // Only open the auth flow when the embedded widget is not rendered
        if (!isRenderingEmbeddedAuthFlow) {
            setShowAuthFlow(true);
        }
    }, [
        setSocialProvider,
        clearStackAndPush,
        isRenderingEmbeddedAuthFlow,
        setShowAuthFlow,
    ]);
    useEffectOnce(() => {
        // Do not run on server side
        if (isSSR())
            return;
        // TODO: use PlatformService
        const url = new URL(redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : window.location.href);
        const dynamicOauthState = url.searchParams.get('dynamicOauthState');
        const dynamicOauthCode = url.searchParams.get('dynamicOauthCode');
        if (!dynamicOauthState || !dynamicOauthCode) {
            return;
        }
        const socialStorageItem = searchSocialStorageByState(dynamicOauthState);
        if (!socialStorageItem)
            return;
        // we got back the dynamicOauthCode from the oauth provider, set it here so we can use it to sign in
        socialStorageItem.code = dynamicOauthCode;
        setSocialStorageItem(socialStorageItem);
        // Clear the state from local storage
        deleteSocialStorage(socialStorageItem.provider);
    });
    useEffectOnceCondition(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!socialStorageItem)
            return;
        // Update UI to reflect the original state
        if (socialStorageItem.mode === 'signin') {
            if (getDynamicClient().user) {
                logger.error(new DynamicError('User is already logged in'));
                return;
            }
            updateInterfaceStateForSignIn(socialStorageItem);
        }
        else if (socialStorageItem.mode === 'link') {
            if (!getDynamicClient().user) {
                logger.error(new DynamicError('User not logged in'));
                return;
            }
            // Link was called from the widget, so show the profile on redirect
            if (socialStorageItem.showWidgetAfterConnection) {
                setDynamicWidgetView('profile');
                setShowDynamicUserProfile(true);
            }
        }
        yield completeConnection({
            authCode: socialStorageItem.code,
            authMode: socialStorageItem.mode,
            captchaToken: socialStorageItem.captchaToken,
            provider: socialStorageItem.provider,
            state: socialStorageItem.state,
            verifier: socialStorageItem.codeVerifier,
        });
        if (socialStorageItem.triggerFundFromExchangeOnSuccess) {
            promptAmountAndFundWithExchange({
                exchange: socialStorageItem.triggerFundFromExchangeOnSuccess,
            });
        }
    }), Boolean(socialStorageItem) && sdkHasLoaded);
};

export { useRedirectSocialHandler };
